<template>
  <div class="capture-step-indicator">
    <div class="steps-container">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="step-item"
        :class="{
          'active': currentStep === index + 1,
          'completed': currentStep > index + 1
        }"
      >
        <div class="step-circle">
          <span v-if="currentStep > index + 1" class="check-icon">
            <i class="ni ni-check-bold"></i>
          </span>
          <span v-else>{{ index + 1 }}</span>
        </div>
        <div class="step-label">{{ step.label }}</div>
        <div v-if="index < steps.length - 1" class="step-line"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaptureStepIndicator',
  props: {
    currentStep: {
      type: Number,
      required: true,
      validator: (value) => value >= 1 && value <= 5
    }
  },
  data() {
    return {
      steps: [
        { label: 'Введение' },
        { label: 'Настройка' },
        { label: 'Ожидание' },
        { label: 'Проверка' },
        { label: 'Готово' }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.capture-step-indicator {
  padding: 1.5rem 0;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #f0f0f0;

  .steps-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    max-width: 600px;
    margin: 0 auto;
  }

  .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex: 1;

    &:last-child {
      flex: 0;
    }

    .step-circle {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-color: #e9ecef;
      color: #6c757d;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      font-size: 0.9rem;
      transition: all 0.3s ease;
      position: relative;
      z-index: 2;

      .check-icon {
        font-size: 0.85rem;
      }
    }

    .step-label {
      margin-top: 0.5rem;
      font-size: 0.75rem;
      color: #6c757d;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      transition: color 0.3s ease;
    }

    .step-line {
      position: absolute;
      top: 18px;
      left: calc(50% + 22px);
      width: calc(100% - 44px);
      height: 2px;
      background-color: #e9ecef;
      z-index: 1;
      transition: background-color 0.3s ease;
    }

    // Active step
    &.active {
      .step-circle {
        background-color: #4361EE;
        color: #fff;
        box-shadow: 0 0 0 4px rgba(67, 97, 238, 0.2);
      }

      .step-label {
        color: #4361EE;
        font-weight: 600;
      }
    }

    // Completed step
    &.completed {
      .step-circle {
        background-color: #52c41a;
        color: #fff;
      }

      .step-label {
        color: #52c41a;
      }

      .step-line {
        background-color: #52c41a;
      }
    }
  }
}

// Responsive
@media (max-width: 576px) {
  .capture-step-indicator {
    .steps-container {
      padding: 0 0.5rem;
    }

    .step-item {
      .step-circle {
        width: 30px;
        height: 30px;
        font-size: 0.8rem;
      }

      .step-label {
        font-size: 0.65rem;
      }

      .step-line {
        top: 15px;
        left: calc(50% + 18px);
        width: calc(100% - 36px);
      }
    }
  }
}
</style>
